import { GRANTS } from '@sonifi/wb-user/services/authorization.service';
import {
  DEFAULT_PRODUCTS_SETTINGS,
  PRODUCTS_PER_GROUP_TYPE,
  STAYCAST_BRANDING_KEYS,
} from '@sonifi/wb-admin/constants/wbAdminConstants';

const hasPermission = (user, permission) =>
  user.permissionsList.some((p) => p.permission === permission); // TO DO: delete this function, use function from user services instead

export const getUsersSplitted = (users) => {
  const activeUsers = [];
  const inactiveUsers = [];

  users.forEach((u) => {
    if (!u.all_groups) {
      u.isSuper = hasPermission(u, GRANTS.ACCOUNT_MANAGEMENT);
      if (u.enabled) {
        activeUsers.push(u);
      } else {
        inactiveUsers.push(u);
      }
    }
  });

  return { activeUsers, inactiveUsers };
};

export const getFilteredProducts = (products = {}, groupType) => {
  const filteredProducts = {};

  Object.keys(products)
    .filter((key) => key !== 'branding')
    .forEach((key) => {
      if (
        PRODUCTS_PER_GROUP_TYPE[groupType]?.includes(key) &&
        products[key].settings
      ) {
        filteredProducts[key] = products[key];
      }
    });

  return filteredProducts;
};

export const getProductsMapped = ({ products = [], productsSettings = [] }) => {
  const productsMapped = {};
  products
    .filter((p) => p.id !== 'medications')
    .forEach((p) => {
      const settings =
        productsSettings.find((ps) => ps.product === p.uri) ||
        DEFAULT_PRODUCTS_SETTINGS[p.id];
      productsMapped[p.id] = {
        ...p,
        settings,
      };
    });

  return productsMapped;
};

export const getChildrenGroupsMapped = (allGroups = [], childrens) =>
  childrens.map((childUri) => allGroups.find((g) => g.uri === childUri));

export const isCustomStaycast = ({ selectedPreset = {}, parentPreset = {} }) => (
    selectedPreset.appIcon !== parentPreset.appIcon ||
    selectedPreset.appName !== parentPreset.appName ||
    selectedPreset.supportLink !== parentPreset.supportLink ||
    selectedPreset.supportPhone !== parentPreset.supportPhone
  );

export const getStaycastBrandingBody = (payload) =>
  payload.staycast.preset === STAYCAST_BRANDING_KEYS.tokens
    ? {
        ...payload.staycast[payload.staycast.preset],
        parent: payload.staycast.customData.parent,
      }
    : {
        appName: '',
        appIcon: '',
        supportLink: '',
        supportPhone: '',
        background: payload.staycast[payload.staycast.preset].background,
        footerBackground:
          payload.staycast[payload.staycast.preset].footerBackground,
        brandingImage: payload.staycast[payload.staycast.preset].brandingImage,
        welcomeText: '',
        parent: payload.staycast.customData.parent,
        alternative: payload.staycast[payload.staycast.preset].alternative,
      };
